import * as React from 'react';

import { useIntl } from 'react-intl';
import { Outlet, useParams } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import Tab from 'src/components/navigation/Tab';
import TabRow from 'src/components/navigation/TabRow';
import { reservationMessages } from 'src/features/reservations/utils/messages';

const ReservationTypesLayout = () => {
    const { parkingId } = useParams();
    const { formatMessage } = useIntl();

    return (
        <>
            <TabRow>
                <Tab end to={`/parking-management/${parkingId}/reservations/dynamic`}>
                    {formatMessage(reservationMessages.dynamicPlans)}
                </Tab>
                <Tab to={`/parking-management/${parkingId}/reservations/fixed`}>
                    {formatMessage(reservationMessages.fixedPlans)}
                </Tab>
            </TabRow>

            <MainLayout>
                <Outlet />
            </MainLayout>
        </>
    );
};

export default ReservationTypesLayout;
